import App from "./App.svelte";
export default new App({
    target: document.body,
    props: {
    // version: "1.2.3",
    }
});
